var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComparison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.962 0H1.038a.998.998 0 0 0-.566.178 1.086 1.086 0 0 0-.383.477c-.082.195-.108.41-.076.62.032.21.121.407.257.564l3.433 3.998v3.77c0 .075.02.147.057.21.037.062.09.112.153.144a.358.358 0 0 0 .393-.047L5 9.325l1.158-.98a.411.411 0 0 0 .139-.306V5.837L9.73 1.84c.136-.157.225-.353.257-.564.032-.21.006-.425-.076-.62a1.086 1.086 0 0 0-.383-.477A.998.998 0 0 0 8.962 0Z",
    fill: "#707B7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparison);
export default __webpack_public_path__ + "static/media/comparison.43bcba73eb1ae0981c625bd22b85d766.svg";
export { ForwardRef as ReactComponent };